import "./fonts.less";

const Fonts = {
  regular: 'Roboto',
  bold: 'Roboto-Bold',
  light: 'Roboto-Light',
  thin: 'Roboto-Thin',
  mono: {
    regular: 'RobotoMono', 
    bold: 'RobotoMono-Bold',
    light: 'RobotoMono-Light',
    thin: 'RobotoMono-Thin',
  }
};

export default Fonts;
